import { render, staticRenderFns } from "./GlobalSearchUser.vue?vue&type=template&id=135fe6cf&"
import script from "./GlobalSearchUser.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports